import Head from 'next/head'
import PageHeaderBanner from '@bww/beke-ui/PageHeader'
import YourDreamCTA from '@bww/beke-ui/YourDreamCTA'
import { sanityClient } from '@bww/beke-lib/sanity-client'
import Faqs from '@bww/beke-ui/Faqs/Faqs'

export default function FAQsPage({ faqs }) {
  return (
    <>
      <Head>
        <title>Frequently Asked Questions</title>
        <meta
          name="description"
          content="Answers to common questions about bathroom design and our workflow."
        />
      </Head>
      <PageHeaderBanner title="FAQs" />
      <div className="pageContainer">
        <Faqs faqs={faqs} />
      </div>
      <YourDreamCTA animated={false} />
    </>
  )
}

export async function getStaticProps() {
  const { faqs } = await sanityClient.fetch(
    `*[_id == "be-faqs"][0]{
      faqs
    }`,
  )

  return {
    props: {
      faqs,
    },
  }
}
